import React, { useState } from "react";
import { IonButton, IonIcon, IonToast } from "@ionic/react";
import { linkOutline, arrowRedoOutline } from "ionicons/icons";

const ShareBtn = ({ post }) => {
  const [showToast, setShowToast] = useState(false);

  const postUrl = `${window.location.origin}/post/${post._id}`;

  const copyLink = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(postUrl);
      } else {
        // Fallback for older browsers/webviews
        const tempInput = document.createElement("input");
        tempInput.value = postUrl;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
      }
      setShowToast(true);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <>
      <IonButton
        fill="clear"
        color="medium"
        className="sidebar-icon post-btns__btn post-btns__reply no-padding-btn ion-no-padding"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          copyLink();
        }}
        title="Share"
        aria-label="Share post"
      >
        <IonIcon icon={arrowRedoOutline} />
      </IonButton>

      <IonToast
        isOpen={showToast}
        onDidDismiss={() => setShowToast(false)}
        message="Link copied to clipboard!"
        duration={3000}
        position="bottom"
        color="dark"
        icon={linkOutline}
      />
    </>
  );
};

export default ShareBtn;

